import { render } from "./BookingForm.vue?vue&type=template&id=24c19692&scoped=true"
import script from "./BookingForm.vue?vue&type=script&lang=js"
export * from "./BookingForm.vue?vue&type=script&lang=js"

import "./BookingForm.vue?vue&type=style&index=0&id=24c19692&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c19692"]])

export default __exports__